import React from 'react'
import Faq from './Faq'

export default function MldFaq(props) {
    return <div className="faq-main section-max-width">
        <p className="inner-title">FAQs</p>
        <Faq faqs={props.faqs} />
    </div>
}